import { defineMessages } from 'react-intl';

export const youtubePanoramaMessages = defineMessages({
  recentTransmissionTitle: {
    id: 'logger.youtubePanorama.recentTransmissionTitle',
    defaultMessage: 'Última transmisión',
  },
  recentTransmissionsTitle: {
    id: 'logger.youtubePanorama.recentTransmissionsTitle',
    defaultMessage: 'Últimas transmisiones',
  },
  viewAll: {
    id: 'logger.youtubePanorama.viewAll',
    defaultMessage: 'Ver todas las transmisiones',
  },
  noRecentBroadcasts: {
    id: 'logger.youtubePanorama.noRecentBroadcasts',
    defaultMessage: 'Sin transmisiones recientes',
  },
});
